import { HttpErrorResponse } from '@angular/common/http';
import { ElementRef } from '@angular/core';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import {
  HANDOVER_STATUS_ACCEPTED,
  HANDOVER_TYPE_AREA_REASON_2_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
  HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
  HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_4_PUL_TO_OPE_ID,
  PERMISSION_ENGINEERING_COMPLETION,
} from 'src/app/handover-constants';
import { Image } from 'src/app/interfaces/image';
import {
  Supplier,
  WellTree,
  WellTreeAttachment,
  WellTreeComponent,
  WellTreeComponentsVisibility,
} from 'src/app/interfaces/well-tree';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { ImageService } from 'src/app/services/image.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { HandoverImageComponent } from '../handover-image/handover-image.component';
import { PendingChanges } from '../shared/pending-changes.class';
import { WellEvent } from 'src/app/interfaces/event';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-tree',
  templateUrl: './handover-detail-tree.component.html',
  styleUrls: ['./handover-detail-tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailTreeComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() wellId: string | undefined;
  @Input() handoverTypeAreaReasonId: number | undefined;
  @Input() handoverStatusId: number | undefined;
  @Input() readOnlyContent!: boolean;

  isLoading = false;
  designPressure = 0;
  wellheadSize: number | string = '';
  supplierId = 0;
  supplierName = '';
  originalWellTree: WellTree = {} as WellTree;
  wellTree: WellTree = {} as WellTree;
  isDisabledSave = true;
  originalTreeComponents: WellTreeComponent[] = [];
  treeComponents: WellTreeComponent[] = [];
  lastTreeComponents: WellTreeComponent[] = [];
  isDisabled: boolean[] = [];
  componentIndexes: number[] = [];
  displayedColumns = [
    'compDescription',
    'diamIntComp',
    'workingPressure',
    'manufacturer',
    'valveState',
    'actions',
  ];
  hasDataDesignPressure = false;
  hasDataWellheadSize = false;
  hasDataSupplier = false;
  suppliers: Supplier[] = [];
  images: Image[] = [];
  imageLimit = 3;
  isLoadingImages = false;
  hideFooter = true;
  displayComponentsVisbilityToggler = false;
  componentsVisbility = true;
  showFooterNoDataOrign = false;
  isUserFromeEngineering = false;
  fileLimit = 2;
  buttonFile = false;
  uploadfile = false;
  wellTreeAttachment: any;
  wellEvents: WellEvent[] = [];
  confirmedEvents: string[] = [];
  lastEvents: string[] = [];
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    public handoverService: HandoverService,
    public dialogService: DialogService,
    public notificationService: NotificationService,
    public imageService: ImageService,
    public userService: UserService,
    public dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverId) {
      this.isLoading = true;
      if (
        this.handoverTypeAreaReasonId &&
        [
          HANDOVER_TYPE_AREA_REASON_4_PUL_TO_OPE_ID,
          HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
          HANDOVER_TYPE_AREA_REASON_2_CWO_TO_OPE_ID,
          HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
          HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
        ].includes(this.handoverTypeAreaReasonId)
      ) {
        this.getEventsAndloadWellTreeDataAndComponents();
      } else {
        this.loadWellTreeDataAndComponents();
      }
      this.loadWellTreeDataAndComponents();
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handoverId}/well-tree/images`;
      this.getWellTreeImages(this.handoverId);

      if (
        this.handoverTypeAreaReasonId &&
        [
          HANDOVER_TYPE_AREA_REASON_4_PUL_TO_OPE_ID,
          HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
          HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
        ].includes(this.handoverTypeAreaReasonId)
      ) {
        this.displayComponentsVisbilityToggler = true;
      }
      this.showFooterNoDataOrign =
        this.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
      this.isUserFromeEngineering = this.userService.hasPermission(
        PERMISSION_ENGINEERING_COMPLETION
      );

      this.getWellTreeAttachments();
    }
  }

  async getEventsAndloadWellTreeDataAndComponents() {
    await this.getEvents();
    this.loadWellTreeDataAndComponents();
  }

  getSuppliers(): void {
    this.handoverService.getSuppliers().subscribe((bases: Supplier[]) => {
      this.suppliers = bases;
    });
  }

  //TODO se deja una unica cabecera y se agrupan todos los componentes hasta que se implemente la feature 5283
  loadWellTreeDataAndComponents(): void {
    if (this.handoverId && this.wellId && this.handoverStatusId) {
      this.handoverService
        .getWellTree(this.handoverId, this.wellId, this.handoverStatusId)
        .subscribe((wellTrees: WellTree[]) => {
          if (wellTrees.length > 0) {
            const data = wellTrees[0];
            this.designPressure = data.designPressure;
            this.wellheadSize = data.wellheadSize;
            this.wellTree = data;
            this.originalWellTree = data;
            if (data.supplier) {
              this.supplierId = data.supplier.supplierId;
              this.supplierName = data.supplier.supplierName;
              if (data.isSupplierApi) {
                this.hasDataSupplier = true;
              }
            }
            this.treeComponents = [];
            for (let index = 0; index < wellTrees.length; index++) {
              const data = wellTrees[index];
              if (data.components.length > 0) {
                if (data.components[0].wellheadId != null) {
                  if (
                    this.handoverTypeAreaReasonId &&
                    [
                      HANDOVER_TYPE_AREA_REASON_4_PUL_TO_OPE_ID,
                      HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
                      HANDOVER_TYPE_AREA_REASON_2_CWO_TO_OPE_ID,
                      HANDOVER_TYPE_AREA_REASON_2_CWO_TO_OPE_ID,
                      HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
                      HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
                    ].includes(this.handoverTypeAreaReasonId)
                  ) {
                    if (this.confirmedEvents.length > 0) {
                      this.treeComponents = this.treeComponents.concat(
                        data.components.filter(
                          (component) =>
                            !component.eventId ||
                            this.confirmedEvents.includes(component.eventId)
                        )
                      );
                    }
                    if (this.lastEvents.length > 0) {
                      this.treeComponents = this.treeComponents.concat(
                        data.components.filter(
                          (component) =>
                            !component.eventId ||
                            this.lastEvents.includes(component.eventId)
                        )
                      );
                    }
                  } else {
                    this.treeComponents = this.treeComponents.concat(
                      data.components
                    );
                  }
                }
              }
            }
            if (data.wellheadSize != null || data.isWellheadSizeApi) {
              this.hasDataWellheadSize = true;
            }
            if (data.designPressure != null || data.isDesignPressureApi) {
              this.hasDataDesignPressure = true;
            }
          }
          this.setOriginalComponentsValues(this.treeComponents);
          this.getSuppliers();
          this.isLoading = false;
          this.hideFooter = this.treeComponents.length > 0;

          if (this.displayComponentsVisbilityToggler) {
            this.getWellTreeComponentsVisibility();
          }
        });
    }
  }
  setOriginalComponentsValues(treeComponents: WellTreeComponent[]): void {
    treeComponents.map((val) => {
      if (val.comments == null) val.comments = '';
      this.originalTreeComponents.push(Object.assign({}, val));
      this.lastTreeComponents.push(Object.assign({}, val));
      this.isDisabled.push(true);
    });
  }

  openComments(
    treeComponent: WellTreeComponent,
    index: number,
    event: any,
    readOnly: boolean
  ) {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog(
        'Comentarios.',
        this.treeComponents[index].comments,
        target,
        -200,
        -450,
        readOnly
      )
      .afterClosed()
      .subscribe((comments: string) => {
        this.treeComponents[index].comments = comments;
        this.enableSaveButton(index, comments);
      });
  }
  enableSaveButton(index: number, comments: string | undefined) {
    const enable = comments != this.originalTreeComponents[index].comments;
    this.isDisabled[index] = !enable;
    if (!this.componentIndexes.includes(index)) {
      this.componentIndexes.push(index);
    }
    this.reportPendingChanges();
  }

  enableByValveSaveButton(index: number, valve: string | undefined) {
    const enable = valve != this.originalTreeComponents[index].valveState;
    this.isDisabled[index] = !enable;
    if (!this.componentIndexes.includes(index)) {
      this.componentIndexes.push(index);
    }

    this.reportPendingChanges();
  }

  uncheckToggle(index: number) {
    if (
      this.lastTreeComponents[index].valveState ==
      this.treeComponents[index].valveState
    ) {
      this.treeComponents[index].valveState = '';
      this.lastTreeComponents[index].valveState = '';
      if (
        this.originalTreeComponents[index].valveState == 'Abierta' ||
        this.originalTreeComponents[index].valveState == 'Cerrada' ||
        this.originalTreeComponents[index].valveState == 'N/A'
      ) {
        this.isDisabled[index] = false;
        if (!this.componentIndexes.includes(index)) {
          this.componentIndexes.push(index);
        }
      } else {
        const i = this.componentIndexes.indexOf(index);
        this.componentIndexes.splice(i, 1);
        this.isDisabled[index] = true;
      }
    } else {
      this.lastTreeComponents[index].valveState =
        this.treeComponents[index].valveState;
    }
  }

  enableSaveTreeButton() {
    let origSupplierId = null;
    if (this.originalWellTree.supplier) {
      origSupplierId = this.originalWellTree.supplier.supplierId;
    }
    const enable =
      this.wellheadSize != this.originalWellTree.wellheadSize ||
      this.designPressure != this.originalWellTree.designPressure ||
      origSupplierId != this.supplierId;
    this.isDisabledSave = !enable;
  }

  saveComponent(treeComponent: WellTreeComponent, index: number): void {
    this.dialogService
      .openConfirmDialog(
        'Boca de Pozo / Componente',
        '¿Desea guardar los cambios del Componente?'
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          if (this.handoverId) {
            treeComponent.handoverId = this.handoverId;
          }

          const components: WellTreeComponent[] = [];
          components.push(treeComponent);

          this.handoverService
            .saveWellTreeComponent(components)
            .subscribe((savedComponent: WellTreeComponent[]) => {
              if (savedComponent) {
                this.notificationService.notify(
                  'Componente guardado satisfactoriamente',
                  true
                );
                this.isDisabled[index] = true;
                this.originalTreeComponents[index].comments =
                  treeComponent.comments;
                this.originalTreeComponents[index].valveState =
                  treeComponent.valveState;
                this.reportPendingChanges();
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al guardar el Componente',
                  false
                );
              }
            });
        }
      });
  }

  saveMultipleComponents(): void {
    this.dialogService
      .openConfirmDialog(
        'Boca de Pozo / Componente',
        '¿Desea guardar los cambios en los Componentes?'
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const components: WellTreeComponent[] = [];
          for (const index of this.componentIndexes) {
            if (this.handoverId) {
              this.treeComponents[index].handoverId = this.handoverId;
            }
            components.push(this.treeComponents[index]);
          }
          this.handoverService
            .saveWellTreeComponent(components)
            .subscribe((savedComponent: WellTreeComponent[]) => {
              if (savedComponent) {
                this.notificationService.notify(
                  'Componentes guardados satisfactoriamente',
                  true
                );
                for (const index of this.componentIndexes) {
                  this.isDisabled[index] = true;
                  this.originalTreeComponents[index].comments =
                    this.treeComponents[index].comments;
                  this.originalTreeComponents[index].valveState =
                    this.treeComponents[index].valveState;
                }

                this.reportPendingChanges();
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al guardar los Componentes',
                  false
                );
              }
            });
        }
      });
  }

  saveTree(wellTree: WellTree): void {
    this.dialogService
      .openConfirmDialog('Boca de Pozo', '¿Desea guardar los cambios?')
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const supplier = {} as Supplier;
          for (let index = 0; index < this.suppliers.length; index++) {
            const element = this.suppliers[index];
            if (element.supplierId == this.supplierId) {
              supplier.supplierId = element.supplierId;
              supplier.supplierName = element.supplierName;
              break;
            }
          }

          wellTree.supplier = supplier;

          if (wellTree.designPressure != this.designPressure) {
            wellTree.designPressure = this.designPressure;
          }
          if (wellTree.wellheadSize != this.wellheadSize) {
            wellTree.wellheadSize = this.wellheadSize;
          }
          if (wellTree.handoverId == null) {
            wellTree.handoverId = this.handoverId != null ? this.handoverId : 0;
          }
          if (wellTree.wellId == null) {
            wellTree.wellId = this.wellId != null ? this.wellId : '';
          }
          this.handoverService
            .saveWellTree(wellTree)
            .subscribe((savedWellTree: WellTree) => {
              if (savedWellTree) {
                this.notificationService.notify(
                  'Datos guardados satisfactoriamente',
                  true
                );
                this.originalWellTree = savedWellTree;
                this.isDisabledSave = true;
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al guardar Datos Generales de Boca de Pozo',
                  false
                );
              }
            });
        }
      });
  }

  attachImage(): void {
    if (this.handoverId) {
      const dialogRef = this.dialogService.openImageUploadDialog(
        this.handoverId,
        'Adjuntar foto o diagrama',
        500
      );
      dialogRef.afterClosed().subscribe((image) => {
        if (undefined != image) {
          this.images.push(image);
        }
      });
    }
  }

  getWellTreeImages(handoverId: number): void {
    this.isLoadingImages = true;
    this.handoverService
      .getWellTreeImages(handoverId)
      .subscribe((values: Image[]) => {
        this.images = values;
        this.isLoadingImages = false;
      });
  }

  deleteImage(image: Image, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Instalación de Boca de Pozo',
      `¿Está seguro de que desea eliminar la imagen?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoadingImages = true;
        this.imageService.deleteImage(image).subscribe((boolean) => {
          this.images.splice(index, 1);
          this.isLoadingImages = false;
        });
      }
    });
  }

  openImage(image: Image): void {
    const dialogRef = this.dialog.open(HandoverImageComponent, {
      width: '700px',
      height: '600px',
      hasBackdrop: false,
      autoFocus: false,
      data: {
        image: image,
        title: 'Instalación de Boca de Pozo',
      },
    });
  }

  getWellTreeComponentsVisibility(): void {
    if (!this.handoverId) {
      return;
    }
    this.isLoading = true;
    this.handoverService
      .getWellTreeComponentsVisibility(this.handoverId)
      .subscribe((value: WellTreeComponentsVisibility) => {
        if (undefined != value.generalDataComponentsVisible) {
          this.componentsVisbility = value.generalDataComponentsVisible;
        }
        this.isLoading = false;
      });
  }

  saveWellTreeComponentsVisibility(): void {
    if (!this.handoverId) {
      return;
    }
    this.isLoading = true;
    this.handoverService
      .saveWellTreeComponentsVisibility(
        this.handoverId,
        this.componentsVisbility
      )
      .subscribe((saved: boolean) => {
        if (saved) {
          this.notificationService.notify(
            'Datos Generales y Componentes visibles guardados',
            true
          );
        } else {
          this.notificationService.notify(
            'Ocurrió un error al guardar Datos Generales y Componentes visibles',
            false
          );
        }
        this.isLoading = false;
      });
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.treeComponents.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.treeComponents[index].comments !=
          this.originalTreeComponents[index].comments ||
        this.treeComponents[index].valveState !=
          this.originalTreeComponents[index].valveState;
    }
    this.emitPendingChanges(thereAreChanges);
  }

  riskAlertDisabled() {
    let disabled = false;
    if (
      this.handoverTypeAreaReasonId ==
        HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID ||
      this.handoverTypeAreaReasonId == HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID
    ) {
      if (this.isUserFromeEngineering) {
        disabled = true;
      }
    }
    return disabled;
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (this.handoverId && file) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      this.handoverService
        .saveWellTreeAttachment(this.handoverId, formData)
        .subscribe(
          (uploaded: WellTreeAttachment[]) => {
            if (uploaded) {
              this.uploadfile = true;
              this.getWellTreeAttachments();
            }
          },
          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.isLoading = false;
    }
  }

  getWellTreeAttachments(): void {
    if (this.handoverId) {
      this.handoverService
        .getWellTreeAttachments(this.handoverId)
        .subscribe((file: WellTreeAttachment[]) => {
          if (file) {
            this.wellTreeAttachment = file;
            this.buttonFile = true;
            this.uploadfile = true;
          }
        });
    }
  }

  deleteWellTreeAttachment(file: any): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Instalación de Boca de Pozo',
      `¿Está seguro de que desea eliminar el archivo?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (!this.handoverId) {
          return;
        }
        this.isLoading = true;
        this.handoverService
          .deleteWellTreeAttachment(this.handoverId, file)
          .subscribe((res: boolean) => {
            if (res) {
              delete this.wellTreeAttachment;
              this.getWellTreeAttachments();
            }
            this.isLoading = false;
          });
      }
    });
  }

  getEvents(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.handoverService
        .getWellEvents(this.handoverId!, this.wellId!, this.handoverStatusId!)
        .subscribe(
          (values: WellEvent[]) => {
            this.wellEvents = values;
            // recorremos wellEvents para contar los eventos confirmados
            if (this.wellEvents.length > 0) {
              for (let index = 0; index < this.wellEvents.length; index++) {
                const event = this.wellEvents[index];
                if (event.confirmEvent) {
                  this.confirmedEvents.push(event.eventIdOW);
                }
                if (
                  this.handoverTypeAreaReasonId &&
                  [
                    HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
                    HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
                  ].includes(this.handoverTypeAreaReasonId)
                ) {
                  this.lastEvents.push(event.eventIdOW);
                }
              }
            }
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}
